/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, dateCol, intCol } from '@integec/grid-tools/lib/cols'
import R from 'ramda'
import {
  getApiTargetInfo,
  monthsMap,
  DayMap,
  DayMapSelectionChoice,
  getUnitTypeCode,
  // HOURS,
  // HOURS_CHOICES,
} from 'core'
import { connect } from 'react-redux'
import {
  marginiPeakDefinition,
  marginiPeakDefinitionUpdate,
  marginiPeakDefinitionDelete,
} from 'api/pgads.js'
import { Button, DatePicker, Select } from 'antd'
import styled from 'styled-components'
import CommonScreen from 'admin/component/CommonScreen'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
const TableTD = styled.div`
  display: grid;
  align-content: center;
  text-align: end;
  max-width: 100px;
  width: 100px;
`

const retrieveTask = apiTargetInfo => marginiPeakDefinition(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  marginiPeakDefinitionUpdate(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  marginiPeakDefinitionDelete(apiTargetInfo)(data)

const title = 'Peak Definition'

// eslint-disable-next-line no-unused-vars
const MarginPeakDefinition = ({ unitTypeCode, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridGap: '5px',
          gridTemplateColumns:
            '100px 150px 100px 150px 100px 150px 100px 150px 100px 150px 100px',
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <TableTD> Effective Date : </TableTD>
        <div style={{ gridColumnEnd: 'span 3' }}>
          <DatePicker
            style={{ width: '100%' }}
            allowClear
            format="MM/DD/YYYY"
            value={insertData.effectiveDateMoment}
            onChange={d => {
              setInsertData({
                ...insertData,
                effectiveDateMoment: d,
                effectivedate: d.format('YYYY-MM-DD'),
              })
            }}
          />
        </div>

        <TableTD>Unit Type : </TableTD>
        <div style={{ gridColumnEnd: 'span 3' }}>
          <Select
            value={insertData.unittype}
            onChange={unittype => setInsertData({ ...insertData, unittype })}
            style={{ width: '100%', gridColumnEnd: 'span 3' }}
          >
            {Object.keys(unitTypeCode).map(c => (
              <Select.Option key={c} value={c}>
                {c}
                {' - '}
                {unitTypeCode[c]}
              </Select.Option>
            ))}
          </Select>

          {/* <Input
            style={{ width: '100%', gridColumnEnd: 'span 3' }}
            value={insertData.unittype}
            onChange={e => {
              setInsertData({
                ...insertData,
                unittype: e.target.value,
              })
            }}
          /> */}
        </div>
        <div style={{ gridColumnEnd: 'span 3' }} />
        <TableTD>Start Month : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.startmonth}
            onChange={val => setInsertData({ ...insertData, startmonth: val })}
          >
            {Object.keys(monthsMap).map(k => (
              <Select.Option key={k} value={k}>
                {monthsMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>Start Day : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.startday}
            onChange={val => setInsertData({ ...insertData, startday: val })}
          >
            {Object.keys(DayMap).map(k => (
              <Select.Option key={k} value={k}>
                {DayMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>Start Hour 1 : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.starthour1}
            onChange={val => setInsertData({ ...insertData, starthour1: val })}
          >
            {R.range(1, 25).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>Start Hour 2 : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.starthour2}
            onChange={val => setInsertData({ ...insertData, starthour2: val })}
          >
            {R.range(1, 25).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div style={{ gridColumnEnd: 'span 3' }} />
        <TableTD>End Month : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endmonth}
            onChange={val => setInsertData({ ...insertData, endmonth: val })}
          >
            {Object.keys(monthsMap).map(k => (
              <Select.Option key={k} value={k}>
                {monthsMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>End Day : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endday}
            onChange={val => setInsertData({ ...insertData, endday: val })}
          >
            {Object.keys(DayMap).map(k => (
              <Select.Option key={k} value={k}>
                {DayMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>End Hour 1 : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endhour1}
            onChange={val => setInsertData({ ...insertData, endhour1: val })}
          >
            {R.range(1, 25).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>
        <TableTD>End Hour 2 : </TableTD>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endhour2}
            onChange={val => setInsertData({ ...insertData, endhour2: val })}
          >
            {R.range(1, 32).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
        </div>
        <div>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const OaMaPeakDefinitionHeaders = [
    dateCol({ ident: 'effectivedate', display: 'Effectivedate', isKey: true }),
    strCol({
      ident: 'unittype',
      display: 'Unit Type',
      isKey: true,
      ...toSelectionColProps(unitTypeCode),
      width: 200,
    }),
    intCol({
      ident: 'startmonth',
      display: 'Start Month',
      isKey: true,
      ...toSelectionColProps(monthsMap),
    }),
    intCol({
      ident: 'endmonth',
      display: 'End Month',
      isKey: true,
      ...toSelectionColProps(monthsMap),
    }),
    intCol({
      ident: 'startday',
      display: 'Start Day',
      isKey: true,
      ...toSelectionColProps(DayMap),
      choices: DayMapSelectionChoice,
    }),
    intCol({
      ident: 'endday',
      display: 'End Day',
      isFiltered: true,
      ...toSelectionColProps(DayMap),
      choices: DayMapSelectionChoice,
    }),
    intCol({
      ident: 'starthour1',
      display: 'Start Hour 1',
      isKey: true,
      // ...toSelectionColProps(HOURS),
      // choices: HOURS_CHOICES,
    }),
    intCol({
      ident: 'endhour1',
      display: 'End Hour 1',
      isFiltered: true,
      // ...toSelectionColProps(HOURS),
      // choices: HOURS_CHOICES,
      // dataFormatter: h => h,
    }),
    intCol({
      ident: 'starthour2',
      display: 'Start Hour 2',
      isFiltered: true,
      // ...toSelectionColProps(HOURS),
      // choices: HOURS_CHOICES,
    }),
    intCol({
      ident: 'endhour2',
      display: 'End Hour 2',
      isFiltered: true,
      // ...toSelectionColProps(HOURS),
      // choices: HOURS_CHOICES,
    }),
    modifierCol,
    modifiedDateCol,
  ]

  return [
    <CommonScreen
      isAdminScreen={false}
      title={title}
      header={OaMaPeakDefinitionHeaders}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unit}
      autoRetrieve
      // sortOptions={[
      //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
      //   { ident: 'unit', display: 'Unit', sortOrder: 'asc' },
      // ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // widthOffset={550}
      // heightOffset={100}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  unitTypeCode: getUnitTypeCode(state),
})

export default connect(mapStateToProps)(MarginPeakDefinition)
